import { LAYERS, type LayerState } from '../viewer/layers';
import * as st from '../state/store';
import { BrowseTree } from './BrowseTree';
import { track } from '../analytics';

const STATES: Array<{ v: LayerState; label: string }> = [
  { v: 'on', label: 'On' },
  { v: 'ghost', label: 'Faint' },
  { v: 'off', label: 'Off' },
];

export function LayerPanel() {
  const loaded = st.loadedLayers.value;
  if (!st.layersOpen.value && st.panel.value !== 'browse')
    return (
      <button type="button" class="btn layers-chip" aria-expanded="false" onClick={() => (st.layersOpen.value = true)} data-testid="layers-open">
        Layers
      </button>
    );
  return (
    <aside class="layers" aria-label="Body layers" data-testid="layer-panel">
      <div class="browse-head">
        <h2 class="panel-title">Layers</h2>
        <button type="button" class="btn ghost icon small-icon" aria-label="Collapse layers" aria-expanded="true" onClick={() => (st.layersOpen.value = false)} data-testid="layers-close">–</button>
      </div>
      <ul class="layer-list">
        {LAYERS.map((l) => {
          // F22: the female figure has no parts in some layers (muscles); say so rather than offer dead controls.
          const missing = !st.layerInBody(l.id);
          return (
          <li key={l.id} class={`layer-row${missing ? ' unavailable' : ''}`} data-testid={`layer-${l.id}`} data-state={st.layers.value[l.id]} data-unavailable={missing || undefined}>
            <span class="swatch" style={{ background: l.color }} aria-hidden="true" />
            <span class="layer-name" id={`ln-${l.id}`}>
              {l.label}
              {!missing && !loaded.has(l.id) && <span class="spinner" role="status" aria-label="loading" />}
              {missing && <span class="layer-note" id={`lnote-${l.id}`} data-testid={`layer-${l.id}-note`}>Not in the female model yet</span>}
            </span>
            <span class="seg" role="radiogroup" aria-labelledby={`ln-${l.id}`} aria-describedby={missing ? `lnote-${l.id}` : undefined}>
              {STATES.map((s) => (
                <button
                  key={s.v}
                  type="button"
                  role="radio"
                  aria-checked={!missing && st.layers.value[l.id] === s.v}
                  disabled={missing}
                  class={!missing && st.layers.value[l.id] === s.v ? 'on' : ''}
                  onClick={() => {
                    st.setLayer(l.id, s.v);
                    track('layer_change', { system: l.id, state: s.v });
                  }}
                  data-testid={`layer-${l.id}-${s.v}`}
                >
                  {s.label}
                </button>
              ))}
            </span>
          </li>
          );
        })}
      </ul>
      <div class="layer-actions">
        <button type="button" class="btn" onClick={() => st.peel()} data-testid="peel-button">
          {st.peelDone.value ? 'Show all layers' : 'Peel a layer'}
        </button>
        <button type="button" class="btn ghost" onClick={() => st.showAll()} disabled={!st.hidden.value.length && !st.isolate.value} data-testid="show-all">
          Show all
        </button>
        <button type="button" class="btn ghost icon" onClick={() => st.undo()} disabled={!st.canUndo.value} aria-label="Undo" title="Undo (Ctrl+Z)" data-testid="undo">↶</button>
        <button type="button" class="btn ghost icon" onClick={() => st.redo()} disabled={!st.canRedo.value} aria-label="Redo" title="Redo (Ctrl+Shift+Z)" data-testid="redo">↷</button>
      </div>
      {st.panel.value === 'browse' && <BrowseTree />}
    </aside>
  );
}
